import { FC, ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import { AffiliatePermissionsEnum } from 'enums/accessTemplates';

export interface IRoute {
  path?: string;
  element: FC;
  routes?: IRoute[];
  permissions?: AffiliatePermissionsEnum[];
}

interface SwitchRouterProps {
  routes: IRoute[];
  existPermission?: AffiliatePermissionsEnum;
}

const renderRoute = (route: IRoute, existPermission: AffiliatePermissionsEnum): ReactNode => {
  const { path, routes, element: Element, permissions } = route;

  if (permissions && !permissions.some((r) => r === existPermission)) {
    console.warn('return');
    return;
  }

  return (
    <Route key={path} path={path} element={<Element />}>
      {Array.isArray(routes) && routes.map((i) => renderRoute(i, existPermission))}
    </Route>
  );
};

export const SwitchRouter: FC<SwitchRouterProps> = ({ routes, existPermission }) => (
  <Routes>{routes.map((i) => renderRoute(i, existPermission as AffiliatePermissionsEnum))}</Routes>
);

export default SwitchRouter;
